import { inject } from '@angular/core';
import {
  HttpContextToken,
  HttpResponse,
  type HttpInterceptorFn,
} from '@angular/common/http';
import { tap } from 'rxjs';
import { ProgressService } from './progress-service';

export const PROGRESS_TOKEN = new HttpContextToken<unknown>(() => {});

export const progressInterceptor: HttpInterceptorFn = (req, next) => {
  const progress = inject(ProgressService);
  const context = req.context.get(PROGRESS_TOKEN);
  if (!context) {
    return next(req);
  }

  progress.start();
  return next(req).pipe(
    tap({
      next: (e) => {
        if (e instanceof HttpResponse && req.method !== 'GET') {
          progress.complete();
        }
      },
      finalize: () => {
        progress.reset();
      },
    }),
  );
};
